import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import InspectionItem from '../InspectionItem'
import Gallery from '../../../../shared/components/Gallery'
import UserInfo from '../../../../shared/components/UserInfo'
import { FILE_STORAGE } from '../../../../constants'
import { renderFullDate } from '../../../../utils/time'

import { translation, enumtranslate } from '../../../../utils/helpers'
import { formatArrayToString } from '../../../../utils/array'

import './otherdamage.scss'

// Elements
import Button from '../../../../shared/elements/button'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Divider from '../../../../shared/elements/divider'

class OtherDamage extends Component {
  constructor (props) {
    super(props)

    this.renderOtherDamage = this.renderOtherDamage.bind(this)
    this.renderDamages = this.renderDamages.bind(this)
    this.renderImage = this.renderImage.bind(this)
    this.renderContent = this.renderContent.bind(this)
  }

  renderOtherDamage (damage, key) {
    if (!damage.Active) return null
    return (
      <div key={key}>
        {damage.Parts.length !== 0 && (
          <div>
            <h3>{translation('15188')}</h3>
            <Divider />
            {damage.Parts.map(this.renderDamages)}
          </div>
        )}
        {damage.Files.length !== 0 && (
          <div className='category'>
            <h3>{translation('1043')}</h3>
            <Divider />
            <Gallery files={damage.Files} renderImage={this.renderImage} />
          </div>
        )}
        {damage.Comment !== null && (
          <div className='category'>
            <h3>{translation('149')}</h3>
            <Divider />
            <LabelWrapper labelText={(<span><UserInfo user={damage.Comment.UserInfo} />{renderFullDate(damage.Comment.NoteDate)}</span>)}>
              <div>{formatArrayToString(damage.Comment.Note)}</div>
            </LabelWrapper>
          </div>
        )}
      </div>
    )
  }

  renderDamages (part, key) {
    const renderDamage = (dmg, k) => {
      const dmgName = dmg.Type === 10 ? dmg.CustomName : enumtranslate('OtherDamageTypes', dmg.Type)

      return (
        <div key={k}>
          {translation(dmgName)}
        </div>
      )
    }

    let side = ''
    if (part.Part.TaskSide !== 0) {
      side = part.Part.TaskSide === 1 ? translation('213') : translation('214')
      side += ' '
    }

    return (
      <LabelWrapper key={'part_' + key} labelText={side + translation(part.Part.DictionaryKey)}>
        {part.OtherDamages.map(renderDamage)}
      </LabelWrapper>
    )
  }

  renderImage (image, key) {
    const url = FILE_STORAGE + image.ThumbURL
    const fullUrl = FILE_STORAGE + image.FileURL
    return (
      <div key={key}>
        <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
      </div>
    )
  }

  renderContent () {
    const { OtherDamages } = this.props.otherDamage

    return (
      <div>
        {OtherDamages && OtherDamages.map(this.renderOtherDamage)}
        <Link to={'/pricecalculation/' + this.props.order.Id + '/7'}>
          <Button style='secondary' labelText={translation('1208')} />
          {/* <img src='/images/svgs/inspection/add-white.svg' /> */}
        </Link>
      </div>
    )
  }

  render () {
    const title = { icon: '/images/svgs/inspection/damage-other.svg', text: '15187' }

    const onHeaderClick = () => {
      this.props.onHeaderClick('OtherDamage')
    }

    return (
      <InspectionItem onHeaderClick={onHeaderClick} title={title} renderContent={this.renderContent} checked={this.props.otherDamage.Checked} />
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(OtherDamage)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/OtherDamage/index.js